function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6a581ee6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./slinePaymentDetailsNew.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./slinePaymentDetailsNew.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6a581ee6\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./slinePaymentDetailsNew.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a581ee6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/freightForwarding/slinePaymentDetailsNew.vue
// module id = 2170
// module chunks = 0